import { createRoot } from 'react-dom/client';
import './ui/styles.css';
import './ui/mobile.css';
import { Graph, type FoundBusiness, type Me } from '@nandanam/sync';
import { App } from './App';
import { AppStore, errorText, setStore } from './app/store';
import { activeAccount, getMode, getToken, initAuth, loadSaved, saveChosen } from './onedrive/auth';
import { ChooseFolder, Loading, SignIn } from './start/Start';
import { watchForUpdates } from './app/updates';

const root = createRoot(document.getElementById('root')!);

function launch(store: AppStore) {
  setStore(store);
  root.render(<App />);
  void store.start();
  watchForUpdates(store);
}

async function boot() {
  // Demo: sample data in this browser only, never mixed with a Microsoft account.
  if (getMode() === 'demo') return launch(new AppStore('demo'));

  root.render(<Loading />);
  let account;
  try { account = await initAuth(); } catch (e) {
    return root.render(<SignIn error={`Sign-in did not finish: ${errorText(e)}`} />);
  }
  if (!account) return root.render(<SignIn />);

  const graph = new Graph({ getToken });
  const open = (me: Me, biz: FoundBusiness) => {
    saveChosen(account, { me, biz });
    launch(new AppStore('onedrive', { graph, me, biz }));
  };
  // The chosen folder is remembered per account, so the app also opens offline from this device's copy.
  const saved = loadSaved(account);
  if (saved) return launch(new AppStore('onedrive', { graph, ...saved }));
  root.render(<ChooseFolder graph={graph} account={activeAccount()!} onReady={open} />);
}

void boot();

// Home-screen app: lets it open offline and lets Chrome offer "Install app".
if ('serviceWorker' in navigator && location.protocol === 'https:') {
  addEventListener('load', () => { navigator.serviceWorker.register('./sw.js').catch(() => { /* app still works online */ }); });
}
